<script>
  export let part = {};

  const zoneColors = {
    calm: "#6cea9f",
    moderate: "#fff871", 
    high: "#ff8383"
  };
</script>

{#if part.type === "endurance" && part.metrics && (part.metrics.calm || part.metrics.moderate || part.metrics.high)}
  <div style="grid-column:3">
    <!-- Visual bar representation -->
    <div
      style="display: flex; height: 16px; border-radius: 2px; overflow: hidden;"
    >
      {#if part.metrics.calm}
        <div
          style="background-color: {zoneColors.calm}; flex: {parseInt(part.metrics.calm) ||
            0}; display: flex; align-items: center; justify-content: center; color: black; font-size: 11px; font-weight: 500; min-width: 20px;"
        >
          {part.metrics.calm}
        </div>
      {/if}
      {#if part.metrics.moderate}
        <div
          style="background-color: {zoneColors.moderate}; flex: {parseInt(
            part.metrics.moderate
          ) ||
            0}; display: flex; align-items: center; justify-content: center; color: black; font-size: 11px; font-weight: 500; min-width: 20px;"
        >
          {part.metrics.moderate}
        </div>
      {/if}
      {#if part.metrics.high}
        <div
          style="background-color: {zoneColors.high}; flex: {parseInt(part.metrics.high) ||
            0}; display: flex; align-items: center; justify-content: center; color: black; font-size: 11px; font-weight: 500; min-width: 20px;"
        >
          {part.metrics.high}
        </div>
      {/if}
    </div>
  </div>
{/if}
